/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import EmptyState from '@atlaskit/empty-state';
import Image from '@atlaskit/image';
import Text from '@atlaskit/primitives/text';

import EmptySearchResultImage from './assets/empty.svg';

const EmptyStateImage = () => (
  <Image src={EmptySearchResultImage} width={96} alt="No recent items" />
);

const TextWrapper = styled.span({
  maxWidth: '235px',
  marginInline: 'auto',
  display: 'inline-block',
});

export const RecentEmptyState = () => {
  return (
    <EmptyState
      header="Nothing to see here!"
      description={
        <TextWrapper>
          <Text size="small" color="color.text.subtle">
            Once you visit repositories, they’ll show up here.
          </Text>
        </TextWrapper>
      }
      headingLevel={3}
      headingSize="xsmall"
      renderImage={EmptyStateImage}
    />
  );
};
